<template lang="pug">
BriqDialog(
  @close="$emit('cancel')"
  dialogSize="briq-dialog-medium"
  v-if="show"
  )
  h2.heading Sub resource creator
  .resource-creator-fields
    BriqInput(
      ref="nameInput"
      label="Name"
      v-model="newSubResource.name"
      required
      :error="nameError"
      @blur="$v.newSubResource.name.$touch()"
      data-test-id="subresource-creator-modal-name-input"
      )
    EditResourceAvatar(
      :color="newSubResource.color",
      :colors="colors"
      :abbreviation="newSubResource.abbreviation"
      @updateColor="updateColor"
      @updateLetters="updateLetters"
      )
    BriqCheckbox(
      label="Show on planboard"
      v-model="newSubResource.showOnScheduler"
      )
    BriqInput(
      label="Planboard ordering"
      v-model.number="newSubResource.priority"
      ref="priorityInput"
      required
      type="number"
      placeholder="0"
      step="1"
      min="0"
      help="I.e. 1 is at the top of the planboard"
      :error="priorityError"
      @blur="$v.newSubResource.priority.$touch()"
      )
  .button-bar.button-bar--center
    BriqButton.modal__cancel-button(
      variant="secondary"
      data-test-id="subresource-creator-cancel"
      @click="$emit('cancel')"
      ) Cancel
    BriqSubmitButton(
      ref="changeResourceTypeBtn" 
      @click="createSubResource"
      :disabled="!isValid"
      data-test-id="subresource-creator-create-subresource"
      ) Create sub resource
</template>

<script>
import EditResourceAvatar from './EditResourceAvatar.vue'
import resourceColors from './resourceColors.js'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'SubResourceCreatorModal',
  components: { EditResourceAvatar },
  props: { show: Boolean },
  data() {
    return {
      newSubResource: {
        name: '',
        color: '',
        abbreviation: '',
        showOnScheduler: true,
        priority: 0,
        tempKey: '',
      },
      colors: resourceColors,
    }
  },
  computed: {
    nameError() {
      return this.$v.newSubResource.name?.$error ? 'Please enter a name' : ''
    },
    priorityError() {
      return this.$v.newSubResource.priority?.$error ? 'Please enter a planboard ordering' : ''
    },
    isValid() {
      return !this.$v.$invalid
    },
  },
  methods: {
    updateColor(newColor) {
      this.$set(this.newSubResource, 'color', newColor)
    },
    updateLetters(newLetters) {
      this.$set(this.newSubResource, 'abbreviation', newLetters)
    },
    createSubResource() {
      this.newSubResource.tempKey = Math.random()
        .toString(36)
        .substr(2, 10)

      this.$emit('createSubResource', this.newSubResource)
    },
  },
  validations() {
    return {
      newSubResource: {
        name: { required },
        priority: { required },
      },
    }
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.heading
  {fontSizeHeading2}
  text-align center
  margin-bottom space-S

.modal__cancel-button
  margin-right 15px

.button-bar
  margin-top auto
</style>

<style lang="stylus">
@import '~@v/variables.styl'

.resource-creator-fields .briq-form-element
  margin-bottom space-S
</style>
